export default __webpack_public_path__ + "static/media/logo_sihapei_qr.66ce2e6d.png";